import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Loader2, CheckCircle2 } from 'lucide-react';
import { Input } from '@/components/ui/input';
import api from '@/utils/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
    } catch { /* always show success */ }
    setSent(true);
    setLoading(false);
  };

  return (
    <div data-testid="forgot-password-page" className="pb-nav flex items-center justify-center min-h-[70vh] px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-1 text-sm text-zinc-500 hover:text-white transition-colors mb-6">
          <ArrowLeft size={16} /> Volver
        </Link>

        {!sent ? (
          <>
            <div className="w-14 h-14 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center mb-4">
              <Mail size={24} className="text-[#E84C1C]" />
            </div>
            <h1 className="text-xl font-bold">Restablecer contraseña</h1>
            <p className="text-sm text-zinc-500 mt-1 mb-6">Ingresá tu email y te enviaremos instrucciones.</p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                data-testid="forgot-email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="tu@email.com"
                required
                className="bg-zinc-900 border-zinc-800 h-11"
              />
              <button
                data-testid="forgot-submit"
                type="submit"
                disabled={loading}
                className="w-full bg-[#E84C1C] text-white font-medium py-3 rounded-full hover:bg-[#d43f12] active:scale-[0.98] transition-all disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {loading && <Loader2 size={18} className="animate-spin" />}
                Enviar instrucciones
              </button>
            </form>
          </>
        ) : (
          <div className="text-center" data-testid="forgot-success">
            <div className="w-14 h-14 rounded-full bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 size={24} className="text-emerald-400" />
            </div>
            <h2 className="text-lg font-bold">Revisá tu correo</h2>
            <p className="text-sm text-zinc-400 mt-2">Si el correo <span className="text-zinc-200">{email}</span> está registrado, recibirás un enlace para restablecer tu contraseña.</p>
            <Link to="/" className="inline-block mt-6 text-sm text-[#E84C1C] hover:underline">Volver al inicio</Link>
          </div>
        )}
      </div>
    </div>
  );
}
